import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M94 32h12v60H94z" }, null, -1),
    _createElementVNode("circle", {
      cx: "100",
      cy: "32",
      r: "6"
    }, null, -1),
    _createElementVNode("path", { d: "M90 80q-40 0-50 30-8 30 10 52 25 16 38-2 8-20 6-50ZM110 80q40 0 50 30 8 30-10 52-25 16-38-2-8-20-6-50Z" }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "var(--mc-avatar)",
      "stroke-linecap": "round",
      "stroke-width": "4",
      d: "M70 110q-10 20 0 35M130 110q10 20 0 35"
    }, null, -1)
  ]))]))
}
export default { render: render }